module.exports = __webpack_public_path__ + "static/media/check-blue.60e64418.svg";